import React from "react";
import PageTitle from "../PageTitle";
import { doRequest } from "../../helper";
import $ from "jquery";
import { CSVLink } from "react-csv";

const headers = [
  { label: "Leader Name", key: "NAME" },
  { label: "Mobile", key: "mobile" },
  { label: "Post Count", key: "postCount" },
];

export default class MahilaStatewiseCount extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      items: [],
      stateitem: [],
      statelist: [],
      selectedstate: {},
      response: null,
      status: "Active",
    };
    this.stateList = this.stateList.bind(this);
  }
  componentDidMount() {
    this.stateList();
  }
  componentWillReceiveProps(nextProps) {}

  stateListvalue = (e, loadmore, del) => {
    this.setState({ selectedstate: e ? e.target.value : del ? del : "" });
    var settings = {
      url: "https://mmapi.narendramodi.in/v1/mahila-rds/getData",
      method: "POST",
      timeout: 0,
      headers: {
        "Content-Type": "application/json",
      },

      data: JSON.stringify({
        action: "leaderstate",
        state: del ? del.statename : e.target.value,
        index: 0,
      }),
    };

    let ref = this;
    $.ajax(settings).done(function (result) {
      try {
        if (result.resultFlag && result.resultFlag == "1") {
          let loadMoreItems = loadmore
            ? [...ref.state.items, ...result.response]
            : result.response;
          let postCount = 0;
          loadMoreItems.map((item) => {
            postCount += item["postCount"];
          });
          ref.setState(
            {
              response: result,
              items: result.response,
              post_count: postCount,
              type: "leaderstate",
            },
            () => {
              $("#loader").css({ display: "none" });
            }
          );
        }
      } catch (ex) {}
    });
  };

  stateList = () => {
    var form = new FormData();
    form.append("action", "getstatelist");
    form.append(
      "token",
      "gKKZLKeV+7Qz8UpLR2loJ6/v0KyVSqbs+DI1KREOIOTkHwGWRvficfOsUa1joUPu"
    );
    form.append("deviceid", "ffffffff-cb11-0cb1-ffff-ffffd3f1ea4a");

    var settings = {
      url: "https://api.narendramodi.in/mlapiv1",
      method: "POST",
      timeout: 0,
      headers: {
        Cookie:
          "ADRUM_BT=R%3A0%7Cg%3A48c9d406-532c-4eef-98d3-f21dad96c84c6%7Cn%3Atmp_bjp_fb49d1de-d391-478a-ab5f-c84d7b25602e%7Ci%3A29062%7Cd%3A12%7Ce%3A566",
      },
      processData: false,
      mimeType: "multipart/form-data",
      contentType: false,
      data: form,
    };
    let ref = this;
    $.ajax(settings).done(function (response) {
      try {
        response = JSON.parse(response);
        if (response._resultflag && response._resultflag == 1) {
          ref.setState({
            statelist: response.data,
          });
          let del =
            response &&
            response.data.length > 0 &&
            response.data.filter((stateval) => stateval.statename === "Delhi");
          let requiredState = del[0];
          ref.setState(
            {
              selectedstate: requiredState,
            },
            () => {
              ref.stateListvalue("", "loadmore", requiredState);
            }
          );
        }
      } catch (ex) {}
    });
  };

  render() {
    var bread = "Mahila Morcha / StateWise Count";
    var items = this.state.items;
    var type = this.state.type;
    var stateList = this.state.statelist;
    return (
      <div>
        <PageTitle
          title="#Mahila Morcha"
          bread={bread}
          Count={this.state.post_count}
        />
        <div className="wrapper wrapper-content">
          <div>
            <h3>PostCount Filter by : </h3>
            <h3
              style={{
                margin: "-30px 18px 15px 0px",
                color: "#139d13",
                right: "0px",
                position: "absolute",
              }}
            >
              Count : {this.state.post_count && this.state.post_count}
            </h3>
          </div>
          <div className="form-inline form_right" style={{ top: "0px" }}>
            <div className="row row_date_div">
              <div
                className="row"
                style={{
                  "margin-right": "10px",
                  "margin-left": "0px",
                }}
              >
                <select
                  id="state"
                  name="state"
                  className="form-control rigt_mar"
                  onChange={(e) => this.stateListvalue(e)}
                  value={this.state.selectedstate.statename}
                >
                  <option value="">Select Your State</option>
                  {Array.isArray(stateList) &&
                    stateList.map((val, i) => {
                      return (
                        <option
                          value={val.statename}
                          key={i}
                          data-value={val.stateid}
                        >
                          {val.statename}
                        </option>
                      );
                    })}
                </select>
              </div>

              <button
                style={{
                  padding: "0px 10px",
                  "border-radius": "20px",
                  "margin-left": "10px",
                }}
                className="btn-success"
                onClick={() => {
                  window.location.reload();
                }}
              >
                Clear filters
              </button>
              {type === "leaderstate" && (
                <CSVLink
                  style={{
                    margin: "0px 0px -6px 30px",
                    right: "0px",
                    position: "absolute",
                  }}
                  data={items}
                  headers={headers}
                  filename="Mahila_morcha_Statecount.csv"
                >
                  <img
                    style={{ width: "30px" }}
                    alt="image"
                    src="/img/filetype-csv.svg"
                  />
                </CSVLink>
              )}
            </div>
          </div>
        </div>
        <hr style={{ margin: "0px", "border-top": "1px solid black" }} />
        <div className="wrapper wrapper-content">
          <div className="row">
            <div className="col-lg-12">
              <div className="kamal_list">
                <table className="table mt-5">
                  <thead className="thead-dark">
                    <tr>
                      <th>Name</th>
                      <th>Mobile</th>
                      <th>Post Count</th>
                    </tr>
                  </thead>
                  <tbody>
                    {Array.isArray(items) &&
                      items.map((value, index) => {
                        return (
                          <tr>
                            <td>{value.NAME ? value.NAME : "null"}</td>
                            <td>{value.mobile ? value.mobile : "null"}</td>
                            <td>{value.postCount ? value.postCount : "0"}</td>
                          </tr>
                        );
                      })}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/Components/MahilaMorcha/MahilaStatewiseCount.jsx